import React, { useEffect, useRef, useState } from "react";
import { Carousel } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Popups from "./Modals/Popups";
import PersonalizedActionModal from "./Modals/PersonalizedActionModal";
import { TimeSliderMpc } from "./Components/TimeSliderMpc";
import HelmetMetaTag from "./Components/HelmetMetaTag";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCoverflow, EffectCreative } from "swiper/modules";
import { motion, AnimatePresence } from "framer-motion";

import "swiper/css";
import "swiper/css/effect-creative";
import "swiper/css/effect-coverflow";
import useWindowWidth from "../hooks/useWindowWidth";

var techonologiesName = [
  {
    Technology: "Frontend/Backend",
  },
  {
    Technology: "APIs Used",
  },
  {
    Technology: "Database & Integration",
  },
];

var techstackImages = [
  {
    Technology: "Frontend/Backend",
    Images: [
      {
        Img: "/images/html-mpc.svg",
        alt: "HTML",
        title: "HTML",
      },
      {
        Img: "/images/css-mpc.svg",
        alt: "Css",
        title: "CSS",
      },
      {
        Img: "/images/bootstrap-mpc.svg",
        alt: "Bootstrap",
        title: "Bootstrap",
      },
      {
        Img: "/images/shopify-mpc.svg",
        alt: "Shopify",
        title: "Shopify",
      },
      {
        Img: "/images/laravel-mpc.svg",
        alt: "Laravel",
        title: "Laravel",
      },
      {
        Img: "/images/Technology/jquery-mpc.svg",
        alt: "jquery",
        title: "jquery",
      },
    ],
  },

  {
    Technology: "Api's used",
    Images: [
      {
        Img: "/images/rest-api.svg",
        alt: "Rest-api",
        title: "Rest-api",
      },
      {
        Img: "/images/fedex.svg",
        alt: "Fedex",
        title: "Fedex",
      },
      {
        Img: "/images/market-wagon.svg",
        alt: "Market-wagon",
        title: "Market-wagon",
      },
      {
        Img: "/images/uds.svg",
        alt: "United Delivery Service",
        title: "United Delivery Service",
      },
      {
        Img: "/images/now-delivery.svg",
        alt: "Now-delivery",
        title: "Now-delivery",
      },
    ],
  },

  {
    Technology: "Database & Integration",
    Images: [
      {
        Img: "/images/sql.svg",
        alt: "MySql",
        title: "MySql",
      },
      {
        Img: "/images/webhooks.svg",
        alt: "Webhooks",
        title: "Webhooks",
      },
      {
        Img: "/images/sendgrid-mpc.svg",
        alt: "Sendgrid",
        title: "Sendgrid",
      },
      {
        Img: "/images/twilio.svg",
        alt: "Twilio",
        title: "Twilio",
      },
      {
        Img: "/images/mailchimp.svg",
        alt: "Mailchimp",
        title: "Mailchimp",
      },
      {
        Img: "/images/zendesk.svg",
        alt: "Zendesk",
        title: "Zendesk",
      },
    ],
  },
];

// var frondenebackendimages = [
//   "/images/frontend-old-new-mobile.svg",
//   "/images/backend-old-new-mobile.svg",
// ];

export default function Ecommerce() {
  const windowWidth = useWindowWidth();
  const [show, setShow] = useState(false);
  const [currentImage, setCurrentImage] = useState(
    "/images/frontend-old-new.svg"
  );
  const [currentMobileImage, setCurrentMobileImage] = useState(
    "/images/frontend-old-new-mobile.svg"
  );
  const [contentHeight, setContentHeight] = useState(0);
  const [videoPlaying, setVideoPlaying] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  var backgroundImages = [
    "/images/background1.svg",
    "/images/background2.svg",
    "/images/background3.svg",
    "/images/background4.svg",
    "/images/background5.svg",
    "/images/background6.svg",
  ];

  var backgroundImagesMobile = [
    "/images/background1-mobile.svg",
    "/images/background2-mobile.svg",
    "/images/background3-mobile.svg",
    "/images/background4-mobile.svg",
    "/images/background5-mobile.svg",
    "/images/background6-mobile.svg",
  ];
  var mpcBackgroundImages =
    windowWidth >= 768 ? backgroundImages : backgroundImagesMobile;

  useEffect(() => {
    const contentDiv = document.getElementById("content-div");
    const height = contentDiv.offsetHeight;
    setContentHeight(height);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevImage) => {
        return prevImage === "/images/frontend-old-new.svg"
          ? "/images/backend-old-new.svg"
          : "/images/frontend-old-new.svg";
      });

      setCurrentMobileImage((prevMobileImage) => {
        return prevMobileImage === "/images/frontend-old-new-mobile.svg"
          ? "/images/backend-old-new-mobile.svg"
          : "/images/frontend-old-new-mobile.svg";
      });
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const boxes = [
    {
      title: "Smart Automation System",
      desc: `We've developed a smart system with automation that
        automatically analyzes and selects the best courier partner
        for each shipment based on the customer's zipcode.`,
      extra: true,
    },
    {
      title: "Optimal Packaging",
      desc: `The system automatically determines the ideal box size and
        the number of boxes required for each order based on the
        items being shipped.`,
    },
    {
      title: "Cost-Effective Solution",
      desc: `Our system helps you save money by choosing the most
        efficient and cost-effective shipping option based on the
        item's size and specific packaging requirements.`,
    },
    {
      title: "Specialized Cold Storage Solutions",
      desc: `Tellos provides specialized solutions for cold storage
        fulfillment, including the selection of the fastest and most
        reliable delivery partners for temperature-sensitive
        products.`,
    },
    {
      title: "Temperature-Controlled Shipments",
      desc: `We ensure that all cold storage items are shipped in a way
        that maintains their thermal integrity, guaranteeing the
        products stay fresh and at the required temperatures
        throughout the delivery process.`,
    },
    {
      title: "Quality & Safety Assurance",
      desc: `Our solutions are designed to store and handle all temperature-sensitive products at specific temperatures, maintaining their quality and safety from our facility to the customer's doorstep`,
    },
  ];
  const visibleBoxes = activeIndex < 3 ? boxes.slice(0, 3) : boxes.slice(3, 6);
  return (
    <React.Fragment>
      <HelmetMetaTag
        titleName="MPC Ecommerce Raw Pet Food Delivery | SprigStack"
        desc="My Pet Carnivore delivers raw, healthy pet food for dogs, cats & more. Get convenient online ordering, automated deliveries, & the fastest shipping options."
        canonical="https://sprigstack.com/portfolio/ecommerce-website-development-for-my-pet-carnivore"
        ogtitle="MPC Ecommerce Raw Pet Food Delivery | SprigStack"
        ogdesc="My Pet Carnivore delivers raw, healthy pet food for dogs, cats & more. Get convenient online ordering, automated deliveries, & the fastest shipping options."
        ogtype="website"
        ogurl="https://sprigstack.com/portfolio/ecommerce-website-development-for-my-pet-carnivore"
        ogimg="https://sprigstack.com/images/ecommerce.png"
      />
      <div className="container-fluid px-0">
        <div className="image-container position-relative">
          <div className="row">
            <Carousel fade interval={1000} indicators={false} controls={false}>
              {mpcBackgroundImages.map((imageUrl, index) => (
                <Carousel.Item
                  key={index}
                  style={{
                    height: windowWidth >= 768 ? `${contentHeight}px` : "auto",
                  }}
                >
                  <img className="" src={imageUrl} alt={`Image ${index + 1}`} />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
          <div
            id="content-div"
            className={`row position-absolute contentContainer pe-0 top-0`}
          >
            <div className="col-md-6 pb-4">
              <h1 className={`ecommerceHeader mt-5 px-lg-0 px-md-0 px-5`}>
                Pet Food E-commerce with Automated Delivery System
              </h1>
              <div className="pt-3">
                <label className={`clientText mb-1 px-5 px-md-0`}>
                  About Client:
                </label>
                <p className={`descText text-justify px-5 px-md-0`}>
                  &nbsp;sells raw pet food for dogs, cats, and other animals,
                  believing it to be the optimal healthy diet for them. Bringing
                  raw carnivorous diets with convenient online delivery for pet
                  parents who care.
                </p>
              </div>
              <div className="row mt-4 d-flex justify-content-center">
                <div className="col-md-4 col-8 my-2">
                  <div className="ecommerceCard p-2">
                    <span>
                      <label className="ecommerceCardText">500+</label>
                      <br />
                      Daily Orders
                    </span>
                  </div>
                </div>
                <div className="col-md-4 col-8 my-2">
                  <div className="ecommerceCard p-2">
                    <span>
                      <label className="ecommerceCardText">10000+</label>
                      <br />
                      Happy Customers
                    </span>
                  </div>
                </div>
                <div className="col-md-4 col-8 my-2">
                  <div className="ecommerceCard p-2">
                    <span>
                      <label className="ecommerceCardText">10+</label>
                      <br />
                      Couriers Integrated
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 text-end px-0">
              <img
                src="/images/ecommerce.png"
                className="img-fluid"
                style={{
                  height: windowWidth >= 768 ? `${contentHeight}px` : "345px",
                }}
                alt=""
              />
            </div>
          </div>
        </div>

        <div className="px-6">
          <div className="text-center technology mt-md-5 mt-4">
            <h2 className="technology">Technology Stack</h2>
            <div>
              <img
                src="/images/hrImg.png"
                alt=""
                className="img-fluid mb-md-5 mb-2"
              />
            </div>
          </div>

          <div className="">
            <TimeSliderMpc
              TechnologyContent={techonologiesName}
              TechnologyImages={techstackImages}
            />
          </div>
        </div>

        <div className="p-2 client-requirements py-md-2 py-2">
          <div className="text-center technology">
            <div className="p-2 client-requirements mt-3">
              <div className="text-center technology mt-md-5">
                <h2 className="technology">Client Requirements</h2>
                <div>
                  <img
                    src="/images/hrImg.png"
                    alt=""
                    className="img-fluid mb-md-5 mb-3"
                  />
                </div>
              </div>
              <div className="text-center">
                <LazyLoadImage
                  effect="blur"
                  src={
                    windowWidth >= 991
                      ? "/images/client-requirements.svg"
                      : "/images/client-requirements-mobile.svg"
                  }
                  className="img-fluid ps-md-5 p-1"
                  alt="client-requirements"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="text-center technology mt-md-5 mt-4 mobile">
          <h2 className="technology">SprigStack Solution</h2>
          <div>
            <img
              src="/images/hrImg.png"
              alt=""
              className="img-fluid mb-md-5 mb-3"
            />
          </div>
        </div>
        <div className="row px-6 mt-4 d-flex align-items-center">
          <div className="col-md-6">
            <LazyLoadImage
              effect="blur"
              src="/images/sprigstack-solution.svg"
              className="img-fluid"
              alt="sprigstack-solution"
            />
          </div>

          <div className="col-md-6 mt-5 p-md-2">
            <div className="desktop">
              <h2 className="technology">SprigStack Solution</h2>
              <div>
                <img
                  src="/images/hrImg.png"
                  alt=""
                  className="img-fluid mb-md-5 mb-3"
                />
              </div>
            </div>
            <div className="col-md-6 mt-2 d-none">
              <LazyLoadImage
                effect="blur"
                src="/images/sprigstack-solution.svg"
                className="img-fluid"
                alt="sprigstack-solution"
              />
            </div>
            <p className="ss-para text-justify">
              <p>
                SprigStack transformed MPC online store with a custom solution
                designed for growth, which included migrating from WordPress to
                Shopify.
              </p>
              <p className="mt-2">
                We improved the user experience by incorporating an upgraded
                modern interface, integrating a new delivery partner,
                implementing innovative delivery solutions, and automating the
                purchasing process.
              </p>
              <p className="mt-2">
                This internal efficiency translates to quicker order processing,
                faster response times for customer inquiries, and an overall
                more positive customer experience.
              </p>
            </p>
          </div>
        </div>

        <div className="text-center technology mt-md-5 mt-2">
          <h2 className="technology">Major UI & UX Improvements </h2>
          <div>
            <img
              src="/images/hrImg.png"
              alt=""
              className="img-fluid mb-md-5 mb-3"
            />
          </div>

          {windowWidth >= 768 ? (
            <>
              {/* <img
                src="/images/frontend-old-new.svg"
                alt="Default Image"
                className="img-fluid"
                onMouseOver={(e) =>
                  (e.currentTarget.src = "/images/backend-old-new.svg")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.src = "/images/frontend-old-new.svg")
                }
              /> */}
              <img
                src={currentImage}
                alt="Ui improvements"
                className="img-fluid"
              />
            </>
          ) : (
            <>
              {/* <Carousel interval={2000} indicators={false} controls={false}>
                {frondenebackendimages.map((imageUrl, index) => (
                  <Carousel.Item key={index}>
                    <img
                      className="img-fluid mt-3"
                      src={imageUrl}
                      alt={`Image ${index + 1}`}
                    />
                  </Carousel.Item>
                ))}
              </Carousel> */}
              <img
                src={currentMobileImage}
                alt="Ui improvements"
                className="img-fluid"
              />
            </>
          )}
        </div>

        <div className="container-fluid horizontal-padding">
          <div className="technology text-center">
            <h2 className="technology">
              <LazyLoadImage
                effect="blur"
                src="/images/telloss-logo.png"
                className="img-fluid pe-3"
                alt="telloss-logo"
              />
              (Cold storage fulfillment)
            </h2>
            <div>
              <img
                src="/images/hrImg.png"
                alt=""
                className="img-fluid mb-md-5 mb-3 "
              />
            </div>
          </div>
          {windowWidth >= 768 ? (
            <div className="row position-relative m-0">
              <div className="col-md-6 p-0 align-content-center">
                <div className="row mx-0">
                  <AnimatePresence mode="wait">
                    {visibleBoxes.map((box, i) => (
                      <motion.div
                        key={i + (activeIndex < 3 ? "first" : "second")}
                        className={`col-12 mpc-fulfillment-box py-3 mt-3 ${
                          activeIndex % 3 === i ? "active-box" : ""
                        }`}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.4 }}
                      >
                        <h3 className="a2-font-features-6">{box.title}</h3>
                        <div className="a2-font-features-7 mt-2">
                          {box.desc}
                        </div>
                        {box.extra && (
                          <div className="a2-font-features-7 mt-2">
                            This includes partners like{" "}
                            <b>Market Wagon, FedEx, UPS, USPS, NOW, and UDS.</b>
                          </div>
                        )}
                      </motion.div>
                    ))}
                  </AnimatePresence>
                </div>
              </div>
              <div className="col-md-6 align-self-center text-center">
                <Swiper
                  grabCursor={true}
                  effect={"creative"}
                  slidesPerView={1}
                  creativeEffect={{
                    prev: {
                      shadow: true,
                      translate: [0, 0, -400],
                      opacity: 0,
                    },
                    next: {
                      translate: ["100%", 0, 0],
                      opacity: 0,
                    },
                  }}
                  loop={true}
                  autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                  }}
                  speed={1500}
                  modules={[EffectCreative, Autoplay]}
                  className="creative-swiper"
                  onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                >
                  {Array.from({ length: 6 }).map((_, i) => (
                    <SwiperSlide key={i + "mpc-fulfillment-pics"}>
                      <LazyLoadImage
                        effect="blur"
                        src={`/images/mpc-fulfillment-pic-${i + 1}.png`}
                        alt={`mpc-fulfillment-pic-${i + 1}`}
                        className="img-fluid"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          ) : (
            <Swiper
              effect={"coverflow"}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={"auto"}
              spaceBetween={-40}
              coverflowEffect={{
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 2,
                slideShadows: false,
              }}
              loop={true}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              speed={1500}
              modules={[EffectCoverflow, Autoplay]}
              className="coverFlow-swiper"
            >
              {boxes?.map((box, i) => (
                <SwiperSlide key={i + "mpc-fulfillment-pics"}>
                  <div
                    className="mpc-fulfillment-box p-3"
                    style={{ background: "#fff" }}
                  >
                    <LazyLoadImage
                      effect="blur"
                      src={`/images/mpc-fulfillment-pic-${i + 1}.png`}
                      alt={`mpc-fulfillment-pic-${i + 1}`}
                      className="img-fluid"
                    />
                    <div className="slide-text mt-2">
                      <h3 className="a2-font-features-6">{box.title}</h3>
                      <div className="a2-font-features-7 mt-2">{box.desc}</div>
                      {box.extra && (
                        <div className="a2-font-features-7 mt-2">
                          This includes partners like{" "}
                          <b>Market Wagon, FedEx, UPS, USPS, NOW, and UDS.</b>
                        </div>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>

        <div className="container-fluid horizontal-padding">
          <div className="technology text-center">
            <h2 className="technology">
              Companion Feature (Pet’s Nutrition Advisor)
            </h2>
            <div>
              <img src="/images/hrImg.png" alt="" className="img-fluid mb-3 " />
            </div>
            <div className="row">
              <div
                className="col-md-6 col-12 mx-auto a2-font-features-7 "
                style={{ color: "#737373" }}
              >
                The Pet's Nutrition Advisor is a new smart feature designed to
                help pet owners create and manage customized meal plans for the
                pets in their care.
              </div>
            </div>
          </div>
        </div>
        <div class="position-relative">
          <div class="position-sticky   mpc-slide slide-1  bg-white">
            <div className="row mpc-fulfillment-box mx-4">
              <div className="col-md-6 col-12 py-3 text-center">
                <LazyLoadImage
                  effect="blur"
                  src={`/images/companion-feature-pic-1.png`}
                  alt={`companion-feature-pic-1`}
                  className="img-fluid max80"
                />
              </div>
              <div className="col-md-6 col-12 py-3 align-self-center">
                <div className="position-relative d-inline-block">
                  <div
                    className="back-box"
                    style={{ transform: "rotate(-3.79deg)", left: "10px" }}
                  ></div>

                  <div className="mpc-fulfillment-box p-4 bg-white position-relative rounded shadow">
                    <h3 className="a2-font-features-6">
                      Personalized Profile Creation
                    </h3>
                    <div className="a2-font-features-7 mt-2">
                      Pet owners can provide detailed information about their
                      pet, including:
                    </div>
                    <ul
                      className="a2-font-features-7"
                      style={{ color: "#737373" }}
                    >
                      <li>Name, breed, and date of birth</li>
                      <li>Life stage (e.g., puppy, adult)</li>
                      <li>
                        Current and target weight, along with options to help
                        the pet gain, lose, or maintain a healthy weight.
                      </li>
                      <li>
                        Any food sensitivities or allergies to be excluded from
                        the meal plan.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="position-sticky   mpc-slide slide-2  bg-white">
            <div
              className={`row mpc-fulfillment-box mx-4 ${
                windowWidth <= 768 ? "column-reverse" : ""
              }`}
            >
              <div className="col-md-6 col-12 py-3 align-self-center">
                <div className="position-relative d-inline-block">
                  <div
                    className="back-box"
                    style={{ transform: "rotate(3.79deg)", right: "10px" }}
                  ></div>

                  <div className="mpc-fulfillment-box p-4 bg-white position-relative rounded shadow">
                    <h3 className="a2-font-features-6">Customized Meal Plan</h3>
                    <div className="a2-font-features-7 mt-2">
                       Based on the pet's profile, the feature generates a
                      tailored meal plan. This plan is delivered on a recurring
                      basis, with customizable delivery intervals (e.g., every 5
                      or 6 weeks) to ensure freshness and nutritional
                      consistency.
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12 py-3 text-center">
                <LazyLoadImage
                  effect="blur"
                  src={`/images/companion-feature-pic-2.png`}
                  alt={`companion-feature-pic-2`}
                  className="img-fluid max80"
                />
              </div>
            </div>
          </div>
          <div class="position-sticky   mpc-slide slide-3 bg-white">
            <div
              className={`row mpc-fulfillment-box mx-4 ${
                windowWidth <= 768 ? "column-reverse" : ""
              }`}
            >
              <div className="col-md-6 col-12 py-3 align-self-center">
                <div className="position-relative d-inline-block">
                  <div
                    className="back-box"
                    style={{ transform: "rotate(3.79deg)", right: "10px" }}
                  ></div>

                  <div className="mpc-fulfillment-box p-4 bg-white position-relative rounded shadow">
                    <h3 className="a2-font-features-6">Order Management</h3>
                    <div className="a2-font-features-7 mt-2">
                      Before placing an order, pet owners have the option to
                      review the finalized meal plan and swap out any items they
                      wish.
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12 py-3 text-center">
                <LazyLoadImage
                  effect="blur"
                  src={`/images/companion-feature-pic-3.png`}
                  alt={`companion-feature-pic-3`}
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="position-sticky   mpc-slide slide-4 bg-white">
            <div
              className={`row mpc-fulfillment-box mx-4 ${
                windowWidth <= 768 ? "column-reverse" : ""
              }`}
            >
              <div className="col-md-6 col-12 py-3 align-self-center">
                <div className="position-relative d-inline-block">
                  <div
                    className="back-box"
                    style={{ transform: "rotate(3.79deg)", right: "10px" }}
                  ></div>

                  <div className="mpc-fulfillment-box p-4 bg-white position-relative rounded shadow">
                    <h3 className="a2-font-features-6">
                      Flexible Ordering Options
                    </h3>
                    <div className="a2-font-features-7 mt-2">
                      Users can choose between two convenient ways to order:
                    </div>
                    <ul
                      className="a2-font-features-7"
                      style={{ color: "#000" }}
                    >
                      <li>
                        One-time order
                        <p style={{ color: "#737373" }}>
                          {" "}
                          A single purchase of the customized meal plan.
                        </p>
                      </li>
                      <li>
                        Active Subscription
                        <p style={{ color: "#737373" }}>
                            This is a time-saving option where the system
                          automatically places repeat orders, ensuring the pet's
                          food is delivered on schedule without manual
                          intervention.
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12 py-3 text-center">
                <LazyLoadImage
                  effect="blur"
                  src={`/images/companion-feature-pic-4.png`}
                  alt={`companion-feature-pic-4`}
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="position-sticky   mpc-slide slide-5  bg-white">
            <div className="row mpc-fulfillment-box mx-4">
              <div className="col-md-6 col-12 py-3 text-center">
                <LazyLoadImage
                  effect="blur"
                  src={`/images/companion-feature-pic-5.png`}
                  alt={`companion-feature-pic-5`}
                  className="img-fluid max80"
                />
              </div>
              <div className="col-md-6 col-12 py-3 align-self-center">
                <div className="position-relative d-inline-block">
                  <div
                    className="back-box"
                    style={{ transform: "rotate(-3.79deg)", left: "10px" }}
                  ></div>

                  <div className="mpc-fulfillment-box p-4 bg-white position-relative rounded shadow">
                    <h3 className="a2-font-features-6">
                      Subscription Dashboard
                    </h3>
                    <div className="a2-font-features-7 mt-2">
                      Pet owners have full control over their subscription
                      through a dedicated dashboard. Here, they can:
                    </div>
                    <ul
                      className="a2-font-features-7"
                      style={{ color: "#737373" }}
                    >
                      <li>Pause or cancel their subscription.</li>
                      <li>View the status of current and upcoming orders.</li>
                      <li>Access a history of past orders.</li>
                      <li>
                        Update their pet's profile to adjust the meal plan as
                        their pet's needs change.(not yet present)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center technology mt-md-0 mt-4">
          <h2 className="technology">Automated Order Fulfillment</h2>
          <div>
            <img
              src="/images/hrImg.png"
              alt=""
              className="img-fluid mb-md-5 mb-3"
            />
          </div>
          <div className="row mt-3 position-relative m-0">
            <div className="col-md-6 p-0">
              <LazyLoadImage
                effect="blur"
                src="/images/then.png"
                className="img-fluid"
                alt="then"
              />
            </div>

            <div className="col-md-6 p-0">
              <LazyLoadImage
                effect="blur"
                src="/images/now.png"
                className="img-fluid"
                alt="now"
              />
            </div>
            <div className="col-md-12 position-absolute top-50 start-50 translate-middle hide-arrows">
              <LazyLoadImage
                src="/images/then-now-arrows.png"
                alt="Arrow"
                className="arrow-animation"
              />
            </div>
          </div>
        </div>

        <div
          className="mt-4"
          style={{
            backgroundImage: 'url("/images/img-bg.png")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
          }}
        >
          <div className="row mt-4 d-flex align-items-center">
            <div className="col-md-5 my-2 p-3 p-md-0 text-md-end text-center">
              <img
                src="/images/mpc-animation.gif"
                className="img-fluid mpc-animation"
                alt=""
              />
            </div>
            <div className="col-md-7 text-center custom-padding">
              <label className="mpc-idea mt-3">
                Want a Unique Online Store?
              </label>
              <br />
              <div className="mpc-idea">
                Let's Build Your Custom Ecommerce Website.
              </div>
              <br />
              <button
                className="btn btn mpcBtn mt-4 px-4"
                onClick={() => {
                  setShow(true);
                }}
              >
                GET A FREE CONSULTATION
                <img
                  className="img-fluid ms-2"
                  src="/images/personalizedWhiteArrow.svg"
                  alt=""
                />
              </button>
            </div>
          </div>
        </div>

        <div className="text-center p-5 mt-4 purchasing-mpc">
          <h2 className="technology">
            Purchasing Tools & Smart Delivery Solution
          </h2>
          <div>
            <img
              src="/images/hrImg.png"
              alt=""
              className="img-fluid mb-md-5 mb-3"
            />
          </div>
          <br />

          <LazyLoadImage
            effect="blur"
            src={
              windowWidth >= 991
                ? "/images/automated-notifications.svg"
                : "/images/automated-notifications-mobile.svg"
            }
            className="img-fluid ps-md-5 p-1"
            alt="automated-notifications"
          />
        </div>

        <div className="text-center technology my-md-4 py-4 p-md-3 position-relative bgF7F7F7">
          <h2 className="technology">What our client say..!</h2>
          <div>
            <img
              src="/images/hrImg.png"
              alt=""
              className="img-fluid mb-md-5 mb-3"
            />
          </div>

          <div className="row mt-md-0 px-5">
            <div className="slide-0 text-start w-20 true">
              <span className="text-slide">
                <div>
                  <div className="active d-flex justify-content-center">
                    <div
                      className={`review-video-frame mx-3 `}
                      style={{
                        backgroundImage: `url("/images/AboutUs/Review/Josh.svg")`,
                        height: "250px",
                        width: "250px",
                      }}
                    >
                      <div className="review-video-overlay" />
                      <div className="review-video-center-content z-1">
                        <LazyLoadImage
                          effect="blur"
                          src="/images/AboutUs/Review/PlayButton.svg"
                          alt="Play"
                          className="review-video-play-btn"
                          onClick={() => setVideoPlaying(true)}
                        />
                      </div>
                      <div className="review-video-info">
                        <div className="review-video-name">Josh</div>
                        <div className="review-video-position">
                          General Manager at Tellos
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 mt-md-1 text-center">
                    <img
                      src="/images/video_icon.png"
                      alt=""
                      className="clickable false"
                      onClick={() => setVideoPlaying(true)}
                    />
                  </div>
                  <div className="clickable videoFeedbackLink false text-center">
                    Watch Video Feedback
                  </div>
                </div>
              </span>
            </div>
            {/* <div className="col-md-3 d-flex align-items-center adjsutImage position-relative divhover">
              <LazyLoadImage
                effect="blur"
                src="/images/client-mpc.svg"
                className="img-fluid mpcImg"
                alt=""
              />
              {!videoPlaying && (
                <div className="play-button">
                  <LazyLoadImage
                    effect="blur"
                    src="/images/play-button-mpc.png"
                    className="img-fluid"
                    alt="play"
                    onClick={() => setVideoPlaying(true)}
                  />
                </div>
              )}
            </div> */}

            {/* <div className="col-md-9 mpcClientDiv">
              <div className="mpc-blockquote">
                <label className="mpcClientTxt no-after-quote text-justify mt-2">
                  Ronak and his team handles multiple projects for our telecom
                  channel partner. They develop and maintain our frontend part
                  where we sell products online on desktop and mobile.They also
                  take care of backend and database interactions. Some of our
                  existing softwares shares the usage of same database so
                  SprigStack team makes sure everything is in order.They have
                  been part of our IT team for more than 2 years now and we are
                  very happy with their services.
                </label>
                <div className="mpcClientTxt fw-bold text-justify mt-2">
                  <p>
                    Josh
                    <br />
                    General Manager at Tellos
                  </p>
                </div>
              </div>
            </div> */}

            {videoPlaying && (
              <div className="video-wrapper col-md-12">
                <div className="video-container">
                  <div
                    className="videoClose"
                    onClick={() => setVideoPlaying(false)}
                  >
                    X
                  </div>
                  <iframe
                    className="video-iframe z-3"
                    src="https://www.youtube.com/embed/suR2KwSPuxc?si=hywGRt1TpTUE5GZi"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; fullscreen; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <Popups
          show={show}
          setShow={setShow}
          title="FREE CONSULTATION"
          size="lg"
        >
          <PersonalizedActionModal />
        </Popups>
      </div>
    </React.Fragment>
  );
}
